import classnames from "classnames";
import React, { useMemo } from "react";

import { CartModel } from "@redux/modules/api/data/cart/@types/cart.model";

import { Button } from "@components/General/Button/button.component";

type ProductBundleAddToCartButtonComponentProps = {
    cart?: CartModel;
    bundleSkus: Array<string>;
    onAddToCart: () => void;
    addToCartLoading: boolean;
};

const ProductBundleAddToCartButtonComponent = ({
    cart,
    onAddToCart,
    addToCartLoading,
    bundleSkus,
}: ProductBundleAddToCartButtonComponentProps) => {
    const bundleInCart = useMemo(
        () =>
            bundleSkus.every(bundleSku =>
                cart?.items.find(cartItem => cartItem.sku === bundleSku),
            ),
        [cart?.items, bundleSkus],
    );

    return (
        <Button
            type={"button"}
            color={"primary"}
            disabled={bundleInCart || addToCartLoading}
            outline={bundleInCart}
            onClick={onAddToCart}
        >
            <i
                className={classnames("las la-lg", {
                    "la-plus": !bundleInCart && !addToCartLoading,
                    "la-check": bundleInCart && !addToCartLoading,
                    "la-spinner la-pulse": addToCartLoading,
                })}
            ></i>
            <i className="las la-lg la-shopping-cart"></i>
        </Button>
    );
};

export { ProductBundleAddToCartButtonComponent };
